// AdminRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { hasPrivilegedRole, isTokenExpired } from '../../utils/authUtils';

interface AdminRouteProps {
  element: React.ReactElement;
}

const checkTokenExpiration = (): React.ReactElement | null => {
  const storedAdminAccessTokenExpiration = localStorage.getItem('adminAccessTokenExpiration');
  if (isTokenExpired(storedAdminAccessTokenExpiration)) {
    // Token has expired, navigate to /signin
    return <Navigate to="/signin" replace />;
  }
  return null;
};

const AdminRoute: React.FC<AdminRouteProps> = ({ element }) => {
  const adminAccessToken = localStorage.getItem('adminAccessToken');

  // hasPrivilegedRole, not isActingAsAdmin: an admin who is impersonating must
  // still be able to reach /admin to stop impersonating.
  if (hasPrivilegedRole() && adminAccessToken) {
    const tokenExpirationElement = checkTokenExpiration();
    if (tokenExpirationElement) {
      return tokenExpirationElement;
    }
    return element;
  } else {
    return <Navigate to="/" />;
  }
};

export default AdminRoute;